import { IACDLEvent } from '../../../../../__legacy__/services/eventBus.service';

export const ProjectExportFinishedEventType = Symbol('PROJECT_EXPORT_FINISHED_EVENT');

export class ProjectExportFinishedEvent implements IACDLEvent {
  constructor(public readonly projectId: string) {}

  readonly type: symbol = ProjectExportFinishedEventType;
}
